import {
  JobSpecificCLImage,
  SampleCLImage,
} from '../../../editJournal/toolset/assets/icons';

const data = {
  heading: 'AI-Generated Cover Letter',
  subHeading:
    'Please choose one of the following options for generating a Cover Letter:',
  sampleCoverLetter: {
    headingText: 'Generate a sample cover letter',
    subHeadingText:
      'Choosing this option generates a cover letter using the data present in your resume. Once generated, you may adjust the cover letter specifically for the job you are applying for.',
    image: SampleCLImage,
  },
  jobSpecificCoverLetter: {
    headingText: 'Generate a Job-specific cover letter',
    subHeadingText:
      'Choosing this option generates a cover letter using the data present in your resume AND the job description of the position you are applying for. Once generated, your cover letter is customized for that job and your profile.',
    image: JobSpecificCLImage,
  },
};

export default data;
